import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface BiometricAttendanceRecord {
    punch?: number;
    status?: number;
    timestamp: string;
    tipo: string;
    userId: string;
}

export interface BiometricAttendanceResponse {
    branch_id?: number;
    success: boolean;
    branch_name?: string;
    count?: number;
    message?: string;
    attendance: BiometricAttendanceRecord[];
    timestamp?: string;
}

export interface BiometricImportResult {
    branchCode?: string;
    branchName?: string;
    recordsProcessed?: number;
    recordsSkipped?: number;
    personsMatched?: number;
    schedulesSaved?: number;
}

@Injectable({ providedIn: 'root' })
export class BiometricAttendanceService {
    private http = inject(HttpClient);

    getAttendance(): Observable<BiometricAttendanceResponse> {
        return this.http.get<BiometricAttendanceResponse>(`${environment.apiNfcServer}api/v1/arco/biometrico/attendance`);
    }

    importAttendance(payload: BiometricAttendanceResponse): Observable<any> {
        return this.http.post(`${environment.apiUrl}rrhh/work-schedules/import-biometrico`, payload);
    }
}
